// extracted by mini-css-extract-plugin
export var errorsContainer = "_s2-1";
export var link = "_s2-0";